import { defineStore } from 'pinia';
import { fetchProducts } from "@/services/ppApi";

export const useProductsStore = defineStore('products', {
    state: () => {
        return {
            products: [],
            loading: false,
            error: null
        }
    },
    getters: {
        availableProducts(state) {
            return state.products.filter(product => product.status === 1 && (process.env.VUE_APP_PRODUCTS ? process.env.VUE_APP_PRODUCTS.includes(product.product_main) : ((process.env.VUE_APP_PRODUCT_FREE ? product.product_main !== process.env.VUE_APP_PRODUCT_FREE : product.product_main !== 'free') && (process.env.VUE_APP_PRODUCT_TRIAL ? product.product_main !== process.env.VUE_APP_PRODUCT_TRIAL : product.product_main !== 'trial'))));
        }
    },
    actions: {
        resetProducts() {
            this.$reset();
        },
        async getProducts(forceFetch = false) {
            if(forceFetch || (this.products && this.products.length < 1)) {
                await this.fetchProducts();
            }
            return this.products.length > 0;
        },
        async fetchProducts() {
            this.loading = true;
            this.error = null;

            try {
                const params = {
                    add_details: 1
                };
                const response = await fetchProducts(params);
                if(response.data?.products?.length > 0) {
                    this.products = this.processProducts(response.data.products);
                } else {
                    this.products = [];
                }
            } catch (error) {
                this.products = [];
                this.error = error;
            } finally {
                this.loading = false;
            }
        },
        processProducts(products) {
            return this.sortProducts(this.filterProducts(products));
        },
        filterProducts(products) {
            return process.env.VUE_APP_PRODUCT_PREFIX ? products.filter(product => product.product_prefix === process.env.VUE_APP_PRODUCT_PREFIX) : [];
        },
        sortProducts(products) {
            return products.sort((a, b) => a.price - b.price);
        },
        getProduct(productMain) {
            return this.products.find(product => product.product_main === productMain) || false;
        }
    }
});
